import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from './primeng.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { DataTableComponent } from './components/data-table/data-table.component';
import { OverlayPanelModule } from "primeng/overlaypanel";
import { AccordionModule } from 'primeng/accordion';
import { ReusableDialogComponent } from './components/reusable-dialog/reusable-dialog.component';
import { VendorManagementComponent } from './components/vendor-management/vendor-management.component';
import { VenderSpecficDocumentComponent } from '../components/vender-specfic-document/vender-specfic-document.component';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    DataTableComponent,
    ReusableDialogComponent,
    VendorManagementComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    OverlayPanelModule,
    AccordionModule,
    EditorModule,
    VenderSpecficDocumentComponent
],
  exports: [
    DataTableComponent,
    ReusableDialogComponent,
    VendorManagementComponent,
    EditorModule,
    VenderSpecficDocumentComponent,
    MatMenuModule
  ]
})
export class SharedModule { } 
